import React from "react";
import Nav from "./Nav";
import Home from "./HomeDir/Home";
import About from "./AboutDir/About";
import Portfolio from "./PortfolioDir/Portfolio";
import Service from './ServiceDir/Service';
import Contact from "./ContactDir/Contact"; 
import Err from "./404";
import Foooter from "./Foooter";
import { Switch, Route } from "react-router-dom";
import "tachyons";
import "./App.css";

function App() {
  return (
    <div className="app">
      <Nav />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/portfolio" component={Portfolio} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/service" component={Service} />
        <Route component={Err} />
      </Switch>
      <Foooter />
    </div>
  );
}

export default App;
